import ConvictionInfo from "@classes/conviction-info";
import AccidentInfo from "@classes/accident-info";

export const TaxiInsuranceQuoteTestData = {
   
   /**
    * Step 0 data (Discovery/Contact)
    */
   
   discoveryType: 'Existing Customer',
   referrersName: 'Renewal Notification',
   contactEmail: 'taxi.driver@fleetcorp.com',
   contactPhone: '07555 121212',
   contactPhoneOther: '020 7123 4567',
   contactOptions: ['Email', 'Phone'],
   discountCode: 'ABCD1234',
   
   /**
    * Step 1 : Data (Personal/Employment)
    */
   
   title: 'Mr',
   firstName: 'Jamil',
   lastName: 'Khan',
   birthDate: '1975-08-10',
   
   houseNumber: '12B',
   addressLine1: 'Central Apartments',
   addressLine2: 'City Road',
   
   postCode: 'E1 1AA',
   maritalStatus: 'Married',
   employmentStatus: 'Self-Employed',
   
   // BOOLEAN FIELDS set to 'Yes' or 'No'
   isHomeOwner: 'No', // Changed from 'Rent' to 'No' (or you could use 'Rent' if your backend allows three states)
   hasChildrenUnder16: 'Yes', // Testing 'Yes'
   
   mainOccupation: 'Taxi Driver',
   occupationIndustry: 'Transportation',
   
   /**
    * Step 2 Data (Driving/Claims History)
    */
   
   drivingLicenseType: 'Full UK Manual',
   provideDrivingLicenseNumber: 'Yes',
   britishDrivingLicenseNumber: 'KHAN750810C99AA',
   drivingLicenseDuration: '1 year',
   drivingLicenseDate: '2024-11-01',
   dvlaMedicalConditions: 'No',
   additionalDrivingQualifications: 'Advanced Driving Course',
   additionalDrivingQualificationDate: '2010-03-01',
   
   // BOOLEAN FIELDS set to 'Yes' or 'No'
   isBornInUk: 'No',
   hasNonMotoringCriminalConvictions: 'No',
   otherVehicleUsage: 'No',
   
   hasAccidentClaimsInLast5Years: 'Yes',
   hasMotoringConvictionsInLast5Years: 'Yes', // Testing 'Yes'
   
   lastDateBecameUKResident: '1990-05-15',
   motorAccidentsList: [
      new AccidentInfo({
         type: 'Fire',
         date: '2022-09-01',
         partyAtFault: 'Both parties',
         
      })
   ],
   motorConvictionsList: [
      new ConvictionInfo({
         date: '2022-09-01',
         code: 'PC10',
         points: 3,
         fines: 250,
         banLengthInMonths: 3,
         wasDriverBreathalysed: 'Yes',
         wasOffenceAccidentRelated: 'No',
      }),
   ],
   
   /**
    * Step 3: Vehicle info (Taxi Vehicle)
    */
   
   // BOOLEAN FIELDS set to 'Yes' or 'No'
   isCarRegistrationNumKnown: 'Yes',
   wasCarImported: 'No',
   hasModifications: 'Yes',
   isCarKeptOnSameAddress: 'Yes',
   isEnrolledWithLocalTaxiCompany: 'Yes',
   isAnUberDriver: 'Yes',
   
   carRegistrationNumber: 'LK05 PHV',
   carMakeAndModel: 'Toyota Prius',
   carEstimatedValue: 15000,
   
   manufacturerName: 'Toyota',
   manufacturerModel: 'Prius',
   carRegistrationYear: 2020,
   carAlarmsOrImmobiliser: 'Tracker and Alarm',
   carSeatNumber: 5,
   carDoorNumber: 5,
   carEngineSize: 1798,
   carTransmissionType: 'Automatic',
   
   modificationType: 'Safety & Business',
   modificationDetails: 'Factory-approved partitions and taxi meter installed.',
   
   carPurchased: 'Yes',
   carPurchaseDate: '2023-01-20',
   
   registeredKeeper: 'Policyholder',
   legalOwner: 'Policyholder',
   carImpoundedWithPolice: 'No',
   
   // Duplicates handled below
   
   /**
    * Vehicle usage (PHV Specific)
    */
   
   carParkingAtDay: 'At my home',
   carParkingAtNight: 'Private Garage',
   vehicleKeeperAddress: 'E1 1AA',
   
   wasInsuranceDeclinedBefore: 'No', // BOOLEAN FIELD
   insurerName: 'Premier Taxi Cover',
   
   vehicleUsageType: 'Social , Domestic, Pleasure and Commuting (SDPC)',
   estimatedAnnualMileage: 'Up to 9000',
   
   insuranceCoverageType: 'Comprehensive',
   noClaimsDiscount: 'No NCD',
   
   voluntaryExcessAmounts: 'None',
   insurancePaymentType: 'Annually',
   
   currentOrPreviousInsurerName: 'Alpha Taxi Solutions',
   renewalPriceOfPreviousInsurer: 1200,
   insuranceCoverageStartDate: '2026-01-01',
   
   /**
    * Step 4 (Taxi-Specific Details)
    */
   
   // Duplicates handled with 'Yes'/'No'
   
   taxiVehicleType: 'MPV',
   taxiWorth: 15000,
   taxiCoverageType: 'Comprehensive',
   taxiLicenseDuration: '15+ Years',
   taxiBadgeDuration: '15+ Years',
   taxiBadgeObtainedAt: 'London, UK',
   taxiDriver: 'Jamil Khan',
   taxiMainUsages: 'Carrying Passengers & Deliveries',
   taxiNoClaimDiscountYears: 8,
   privateCarNoClaimDiscountYears: 0,
   
   // BOOLEAN FIELDS set to 'Yes' or 'No'
   hadMadeAnyClaimsInLast5Year: 'No',
   hadMotoringConvictionsInLast5Years: 'Yes',
   doesAcceptCashOrCardPayment: 'Yes', // Assuming 'Both' implies "Yes" to acceptance
   
   addAdditionalComments: 'I operate primarily during night hours (6 PM - 4 AM).',
   
   // BOOLEAN FIELD set to true/false
   termsAgreement: 'Yes',
   
   taxiLicenseIssuerCouncil: 'Tower Hamlets Council',
   taxiBadgeDate: '2008-01-01',
   taxiMaxPassengers: 4,
   localTaxiCompanyName: 'City Fleet Services Ltd',
};